import { render, staticRenderFns } from "./ConnectMailbox.vue?vue&type=template&id=2371b8e2&"
import script from "./ConnectMailbox.vue?vue&type=script&lang=js&"
export * from "./ConnectMailbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports